import React from 'react';

/**
 * 2026-02-04: Brand Logo Radiuslink — badge dipasang di atas card income (pendapatan).
 * Positioned absolute: bottom of pill = top of card border (badge-on-border style).
 * Konsisten di semua tema (Glassmorphism, Paper White, Clean Minimalist, Dark Premium).
 */
export const RadiusLinkBadge = () => {
  return (
    <a
      href="https://radiuslink.id"
      target="_blank"
      rel="noopener noreferrer"
      className="hidden md:inline-flex items-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-0 z-20 group"
      title="RadiusLink — ISP Billing Enterprise"
      data-testid="brand-radiuslink"
    >
      <div
        className="inline-flex items-center h-8 sm:h-9 px-3 rounded-lg bg-white group-hover:bg-white ring-1 ring-slate-300/80 transition-all group-hover:ring-slate-400"
        style={{
          boxShadow:
            '0 4px 12px -2px rgba(15, 23, 42, 0.18), 0 2px 4px -1px rgba(15, 23, 42, 0.10), 0 0 0 1px rgba(255,255,255,0.6) inset',
        }}
      >
        <img
          src="/radiuslink-topbar.png"
          alt="RadiusLink"
          className="h-6 sm:h-7 w-auto object-contain"
          draggable="false"
        />
      </div>
    </a>
  );
};

export default RadiusLinkBadge;
